import { setValidateLanguage } from '@formily/core'
import type { LocaleType } from '@radical/types'

// Formily 已经内置了 zh-CN 和 en-US 的语言包，无需手动注册
// 只需要设置语言环境即可

// 设置 Formily 的国际化
export const setupFormilyI18n = (locale: LocaleType) => {
  // 将 zh_CN 转换为 zh-CN 格式
  const formilyLocale = locale.replace('_', '-')
  setValidateLanguage(formilyLocale)
}

// 切换 Formily 语言
export const changeFormilyLocale = (locale: LocaleType) => {
  setupFormilyI18n(locale)
}
